import React from 'react';

import { FulfillmentOrderItemsListTemplate } from 'themes/modules/order/pages';
import { FulfillmentOrderItemsListViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new FulfillmentOrderItemsListViewStore(rootStore), 'fulfillmentOrderItemsListViewStore')
class FulfillmentOrderItemsList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<FulfillmentOrderItemsListTemplate
				{...this.props}
				change={this.props.fulfillmentOrderItemsListViewStore.change}
				actions={this.props.fulfillmentOrderItemsListViewStore}
				data={this.props.data}
			/>
		);
	}
}

export default FulfillmentOrderItemsList;



// WEBPACK FOOTER //
// ./src/modules/order/pages/FulfillmentOrderItemsList.jsx